if (!customElements.get('product-group')) {

  class productGroup extends HTMLElement {
    localStorageName = ''
    productPageData = ''
    backButtonClicked = false
    closestParentProduct = null

    setLocalStorageName(name) {
      this.localStorageName = name || window.swatchesLocalStorageName || 'product-group';
    }

    async fetchProductPageHTML() {
      const response = await fetch(`/products/${this.productHandle}`)
      const html = await response.text()
      const parser = new DOMParser()
      return parser.parseFromString(html, 'text/html')
    }

    async getProductPageHTML() {
      let lsObj = JSON.parse(localStorage.getItem(this.localStorageName))
      let item = lsObj?.items.find(item => item.data.handle == this.productHandle)

    
      if (item) {
          if (new Date(item.expiryDate) < new Date()) {
              localStorage.removeItem(this.localStorageName)
              this.productPageData = await this.fetchProductPageHTML()
                  .then(doc => this.buildProductPageObject(doc))
              this.updateLocalStorage({
                  data: this.productPageData,
                  expiryDate: new Date().getTime() + 5 * 60 * 1000 // 5 minutes
              });
          } else {
              this.productPageData = item.data;
          }
      } else {
          this.productPageData = await this.fetchProductPageHTML()
              .then(doc => this.buildProductPageObject(doc))
          this.updateLocalStorage({
              data: this.productPageData,
              expiryDate: new Date().getTime() + 5 * 60 * 1000
          });
      }

      return this.productPageData;
  }

    buildProductPageObject(doc) {

      let productPageObject = {
        "handle": this.productHandle,
        "color": '', //product.node.product_color,
        "body-classes": Array.from(doc.body.classList),
        "section-main-product-classes": Array.from(doc.querySelector('.section-main-product > section').classList),
        "metaDescription": doc.head.querySelector('meta[name="description"]')?.outerHTML,
        "canonical": doc.head.querySelector('link[rel="canonical"]')?.outerHTML,
        "title": doc.head.querySelector('title')?.outerHTML,
        "metaOgUrl": doc.head.querySelector('meta[property="og:url"]')?.outerHTML,
        "metaOgTitle": doc.head.querySelector('meta[property="og:title"]')?.outerHTML,
        "metaOgDescription": doc.head.querySelector('meta[property="og:description"]')?.outerHTML,
        "metaOgImage": doc.head.querySelector('meta[property="og:image"]')?.outerHTML,
        "metaOgImageSecureUrl": doc.head.querySelector('meta[property="og:image:secure_url"]')?.outerHTML,
        "metaOgImageWidth": doc.head.querySelector('meta[property="og:image:width"]')?.outerHTML,
        "metaOgImageHeight": doc.head.querySelector('meta[property="og:image:height"]')?.outerHTML,
        "metaOgPriceAmount": doc.head.querySelector('meta[property="og:price:amount"]')?.outerHTML,
        "metaTwitterTitle": doc.head.querySelector('meta[name="twitter:title"]')?.outerHTML,
        "metaTwitterDescription": doc.head.querySelector('meta[name="twitter:description"]')?.outerHTML,
        //"hreflang": doc.head.querySelectorAll('link[hreflang]')?.outerHTML,
        "jsonEmbed": doc.head.querySelector('link[type="application/json+oembed"]')?.outerHTML,
        "analytics": doc.head.querySelector('.analytics')?.outerHTML,
        "script": doc.head.querySelector('#__st')?.outerHTML
      }

      // check to see if they are in the sticky a/b test
      const ajaxContent = doc.querySelectorAll('[data-ajax-content]')
      const ajaxContentArray = Array.from(ajaxContent).map(el => el.outerHTML);
      productPageObject.ajaxContent = ajaxContentArray;

      const mainProductSection = doc.querySelector('.section-main-product');
      const adjacentElements = [];
      let nextSibling = mainProductSection?.nextElementSibling;
      let i = 0;
      while(nextSibling && i < 20) {
          adjacentElements.push(nextSibling.outerHTML);
          nextSibling = nextSibling.nextElementSibling;
          i++;
      }
      productPageObject.mainContentAdjacentElements = adjacentElements;

      return productPageObject
    }

    updateLocalStorage(item) {
      try {
          let lsObj = JSON.parse(localStorage.getItem(this.localStorageName)) || {
              expiryDate: this.expiryDate,
              items: []
          };

          lsObj.items.push(item);
          localStorage.setItem(this.localStorageName, JSON.stringify(lsObj));
      } catch (error) {
          localStorage.removeItem(this.localStorageName);
      }
      this.removeDuplicateItems();
    }

    removeDuplicateItems() {
      let lsObj = JSON.parse(localStorage.getItem(this.localStorageName));

      if (lsObj) {
        // Create a Set to keep track of unique handles
        const uniqueHandles = new Set();

        // Loop through the items array and check for duplicates
        for (let i = 0; i < lsObj.items.length; i++) {
          const item = lsObj.items[i];

          // If the handle is already in the Set, remove the item from the array
          if (uniqueHandles.has(item.data.handle)) {
            lsObj.items.splice(i, 1);
            i--;
          } else {
            // If the handle is not in the Set, add it
            uniqueHandles.add(item.data.handle);
          }
        }

        // Update the local storage
        localStorage.setItem(this.localStorageName, JSON.stringify(lsObj));
      }
    }
  }

  class productGroupList extends productGroup {
    productNodes = []
    afterCursor = ''
    hasNextPage = true
    productGroupName = '' // current page product title
    productGroupData = null
    productGroupHtml = []

    constructor() {
      super()
    }

    connectedCallback() {
      this.setLocalStorageName()
      if (document.querySelector('.product__title h1')) {
        this.productGroupName = document.querySelector('.product__title h1').innerText
      }
      this.productGroupData = this.productGroupData
      this.productGroupHtml = this.productGroupHtml
      this.handleEventListeners()
    }

    handleEventListeners() {

      // Handle back button click
      this.popstateEventListener = (e) => {
        // get popstate previous and new url from the event object

        if (!e?.state?.ajaxedPage) return;

        this.backButtonClicked = true
        let productHandle = window.location.pathname.replace('/products/','')
        let swatchEl = document.querySelector(`product-group-swatch[data-product-handle="${productHandle}"]`)
        
        if (swatchEl) {
          // trigger click event and pass back button value
          swatchEl.dispatchEvent(new CustomEvent('click', { detail: { backButtonClicked: true } }))
          document.dispatchEvent(new CustomEvent("swym:product-pdp-loaded"));
          document.dispatchEvent(new CustomEvent("swym:quick-modal-loaded"));
        }
      }
      addEventListener('popstate', this.popstateEventListener, false);

      // Handle FostrLocalizationForm change event
      /*
      window.addEventListener('FostrLocalizationForm:change', (e) => {
        // remove color swatch local storage
        localStorage.removeItem(this.localStorageName)
      })
      */
    }

    disconnectedCall() {
      removeEventListener('popstate', this.popstateEventListener, false);
      //window.removeEventListener('FostrLocalizationForm:change')
    }

  }
  customElements.define('product-group', productGroupList)


  class productGroupSwatch extends productGroup {

    productHandle = ''
    productPageData = null

    constructor() {
      super();
    }

    connectedCallback() {
      if(this.closest('.product__info-container')){
        this.setLocalStorageName();
        this.setProductHandle(this.dataset.productHandle);
        this.itemsCountCheck();
        this.getProductPageHTML();
        this.handleEventListeners();
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleSwatchClick);
      this.removeEventListener('mouseover', this.handleSwatchMouseover);
      this.removeEventListener('mouseout', this.handleSwatchMouseout);
      this.querySelector('a')?.removeEventListener('click', this.handleInsideLinkClick);
    }

    handleEventListeners() {
      this.addEventListener('click', this.handleSwatchClick);
      this.addEventListener('mouseover', this.handleSwatchMouseover);
      this.addEventListener('mouseout', this.handleSwatchMouseout);
      this.querySelector('a')?.addEventListener('click', this.handleInsideLinkClick);
    }

    async renderSocialProofing(id) {

      if (!(document.querySelector('.social-proofing'))) {
        return;
      }

      try {
        const response = await fetch(window.Shopify.routes.root + `products/${this.dataset.productHandle}?sections=social-proofing&product_id=${id}`);
      
        if (response.ok) {
          const data = await response.json();
          let html = data["social-proofing"];
        
          const scripts_to_run = html.match(/<script spf>([\s\S]*?)<\/script>/gm);
          const scripts = [];
    
          scripts_to_run.forEach(script => {
          script = script.replace("</script>", "").replace("<script spf>", "");
    
          scripts.push(script);
        });

          const newDiv = document.createElement("div");
          newDiv.innerHTML = html;

          document.querySelector('.social-proofing').innerHTML = html;
          
          scripts.forEach(script_to_eval => {
            new Function(script_to_eval)();
          });
          
        } else {
          throw new Error('Error: ' + response.status);
        }
      } catch (error) {
        console.error(error);
      }
    }

    handleSwatchClick = (event) => {
      // handle the click event
      if (event.detail?.backButtonClicked) {
        this.backButtonClicked = true
      }

      if(this.closest('quick-add-modal')){
        this.closestParentProduct = this.closest('quick-add-modal');
      }else{
        this.closestParentProduct = document;
      }

      const id = event.currentTarget.dataset.productId;
    
      this.updatePageHTML()
      this.renderSocialProofing(id)
    }

    handleSwatchMouseover = (event) => {
      // handle the mouseover event
      
      // if swatch is within product card, return
      if(event.target.closest('.card-information') != null) return

      // if window width is less than 768px, return
      if (window.innerWidth < 768) return

      /*
      const selectedColorTextEl = document.querySelector('product-group .js-selected-color')
      if (!selectedColorTextEl) return
      selectedColorTextEl.dataset.colorTitle = selectedColorTextEl.innerText
      selectedColorTextEl.innerText = this.dataset.colorTitle
      */

      const selectedColorTextEl = document.querySelectorAll('product-group .js-selected-color, sticky-atc .product__color-selector--title.js-selected-color');

      if (!selectedColorTextEl) return

      selectedColorTextEl.forEach(selectedColorEl => {
        selectedColorEl.dataset.colorTitle = selectedColorEl.innerText
        selectedColorEl.innerText = this.dataset.colorTitle
      });

    }

    handleSwatchMouseout = (event) => {
      // handle the mouseout event
      // if window width is less than 768px, return
      if (window.innerWidth < 768) return

      const selectedColorTextEl = document.querySelectorAll('product-group .js-selected-color, sticky-atc .product__color-selector--title.js-selected-color');
      if (!selectedColorTextEl) return

      selectedColorTextEl.forEach(selectedColorEl => {
        if( selectedColorEl.dataset.colorTitle ) {
          selectedColorEl.innerText = selectedColorEl.dataset.colorTitle
        }
      });

    }

    handleInsideLinkClick = (event) => {
      event.preventDefault();
    }

    itemsCountCheck() {
      if (!this.localStorageName) return;
      const lsObj = JSON.parse(localStorage.getItem(this.localStorageName))
      if (lsObj && lsObj.items.length >= 25) {
        localStorage.removeItem(this.localStorageName)
      }
    }

    setProductHandle(handle) {
      this.productHandle = handle || this.productHandle
    }


    /*
    handleSwatchMouseover(e) {
      // if window width is less than 768px, return
      if (window.innerWidth < 768) return

      const selectedColorTextEl = document.querySelector('product-group .js-selected-color')
      if (!selectedColorTextEl) return
      selectedColorTextEl.dataset.colorTitle = selectedColorTextEl.innerText
      selectedColorTextEl.innerText = this.dataset.colorTitle
    }

    handleSwatchMouseout(e) {
      // if window width is less than 768px, return
      if (window.innerWidth < 768) return

      const selectedColorTextEl = document.querySelector('product-group .js-selected-color')
      if (!selectedColorTextEl) return
      selectedColorTextEl.innerText = selectedColorTextEl.dataset.colorTitle
    }
    

    handleSwatchClick(e) {

      if (e.detail?.backButtonClicked) {
        this.backButtonClicked = true
      }

      this.updatePageHTML()
    }
    */

    updatePageHTML() {

      const documentClasses = Array.from(document.body.classList)

      const documentHeadObject = {
        "metaDescription": document.head.querySelector('meta[name="description"]'),
        "canonical": document.head.querySelector('link[rel="canonical"]'),
        "title": document.head.querySelector('title'),
        "metaOgUrl": document.head.querySelector('meta[property="og:url"]'),
        "metaOgTitle": document.head.querySelector('meta[property="og:title"]'),
        "metaOgDescription": document.head.querySelector('meta[property="og:description"]'),
        "metaOgImage": document.head.querySelector('meta[property="og:image"]'),
        "metaOgImageSecureUrl": document.head.querySelector('meta[property="og:image:secure_url"]'),
        "metaOgImageWidth": document.head.querySelector('meta[property="og:image:width"]'),
        "metaOgImageHeight": document.head.querySelector('meta[property="og:image:height"]'),
        "metaOgPriceAmount": document.head.querySelector('meta[property="og:price:amount"]'),
        "metaTwitterTitle": document.head.querySelector('meta[name="twitter:title"]'),
        "metaTwitterDescription": document.head.querySelector('meta[name="twitter:description"]'),
        "jsonEmbed": document.head.querySelector('link[type="application/json+oembed"]'),
        "analytics": document.head.querySelector('.analytics'),
        "script": document.head.querySelector('#__st')
      }

      const klavForm = document.querySelector('.klav-form-wrapper');

      if (this.productPageData && this.productPageData['ajaxContent']) {
        let ajaxContentArray = this.productPageData['ajaxContent'];
        if (ajaxContentArray) {
            ajaxContentArray.forEach((ajaxContent) => {
                if (!ajaxContent) return;

                let element = new DOMParser().parseFromString(ajaxContent, 'text/html').body.firstElementChild;

                if (!element) return;

                let datasetAjaxContentValue = element.dataset.ajaxContent;

                if (!datasetAjaxContentValue) return;

                let elementToReplace = this.closestParentProduct.querySelector(`[data-ajax-content="${datasetAjaxContentValue}"]`);
                if (elementToReplace) {
                    elementToReplace.replaceWith(element);
                }
            });
        }
      }

      // remove every adjacentElements after .section-main-product
      let mainProductSection = this.closestParentProduct.querySelector('.section-main-product')

      // while next sibling
      let i = 0;
      while (mainProductSection?.nextElementSibling) {
        // remove next sibling
        mainProductSection?.nextElementSibling.remove()
        if (i==20) break; // precautionary
        i++;
      }

      if (this.productPageData && this.productPageData['mainContentAdjacentElements']) {
        const mainContentAdjacentElements = this.productPageData['mainContentAdjacentElements'];
        if (mainContentAdjacentElements.length) {
          // reverse mainContentAdjacentElements array
          const reversedElements = mainContentAdjacentElements.reverse();

          // add all nextSiblings after mainProductSection
          for (const elementString of reversedElements) {
            const element = new DOMParser().parseFromString(elementString, 'text/html').body.firstElementChild;
            mainProductSection?.insertAdjacentElement('afterend', element);
          }
        }
      }

      if(mainProductSection){

        // Remove existing classes
        document.body.classList.remove(...documentClasses);

        // Add new classes
        document.body.classList.add('ajax-content--loading');

        if (this.productPageData) {
          // Add body classes
          const bodyClasses = this.productPageData['body-classes'];
          if (bodyClasses) {
            document.body.classList.add(...bodyClasses);
          }

          // Update section-main-product classes
          const sectionMainProduct = document.querySelector('.section-main-product > section');
          if (sectionMainProduct) {
            const sectionMainProductClasses = this.productPageData['section-main-product-classes'];
            if (sectionMainProductClasses) {
              sectionMainProduct.classList.add(...sectionMainProductClasses);
            }
          }

          // Update document head
          Object.keys(documentHeadObject).forEach(key => {
            
            const element = documentHeadObject[key];

            if (!element || element.length === 0) {
              return;
            }

            const htmlString = this.productPageData[key];

            if (!htmlString) {
              return;
            }

            if (element.length > 1) {
              element.forEach((el, i) => {
                el.outerHTML = new DOMParser().parseFromString(htmlString[i], 'text/html').querySelector('head').innerHTML;
              });
            } else {
              element.outerHTML = new DOMParser().parseFromString(htmlString, 'text/html').querySelector('head').innerHTML;
            }
          });
        }

        document.body.classList.remove('ajax-content--loading');
        document.body.classList.add('ajax-content--loaded');


        // Remove loading class and add loaded class
        setTimeout(() => {
          document.body.classList.remove('ajax-content--loading');
          document.body.classList.add('ajax-content--loaded');
        }, 200);

        // Update the URL
        if (!this.backButtonClicked) {
          window.history.pushState({ ajaxedPage: true }, '', `/products/${this.productHandle}`);
        }
      }

      // Dispatch the custom events
      document.dispatchEvent(
        new CustomEvent("color_swatch:clicked", {
          bubbles: true,
          detail: { color: () => this.dataset.colorTitle },
        }),
      );
      document.dispatchEvent(new Event("product:swapped"));

      // re-add event listeners in sticky ATC
      var colorSelector = document.querySelector('sticky-atc .product__color-selector');
      var variantSelector = document.querySelector('sticky-atc .product__variant-selector');


      if(colorSelector){

        colorSelector.querySelector('.product__color-selector--wrapper').addEventListener('click', () => {
          colorSelector.classList.toggle('active')
          variantSelector.classList.remove('active')
        })

        variantSelector?.querySelector('.product__variant-selector--wrapper').addEventListener('click', () => {
          variantSelector.classList.toggle('active')
          colorSelector.classList.remove('active')
        })

        document.querySelector('[data-sticky-atc-btn]').addEventListener('click', (event) => {
          event.preventDefault();
          var mainAtc = document.querySelector('product-form .product-form__submit');

          if(mainAtc){
            mainAtc.click();
          }
        })

      }

      // refresh yotpo modules
      var api = new Yotpo.API(yotpo);
      if(api) {
        api.refreshWidgets();
      }

      // refreshing swym wishlist on quick buy modal
      document.dispatchEvent(new CustomEvent("swym:quick-modal-loaded"));
      
      //PDP findation and yotpo modules
      if (window.location.href.indexOf("/products/") > -1) {
        // refreshing swym wishlist
        document.dispatchEvent(new CustomEvent("swym:product-pdp-loaded"));
        
        // reinit of findation app on swatch change
          initWidget();
      }
      console.log('append-html');
      document.querySelector('.klav-form-wrapper')?.remove();

      if (klavForm != null) document.querySelector('product-info').append(klavForm);
      
      /*
      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }
      */

      setTimeout(() => {
        const vieveSociety = document.querySelector('.vieve-society');
        const nonVieveSociety = document.querySelector('.non-vieve-society');
        const customer = swymCustomerId;
        const vieveMetafield = vieveSociety.getAttribute('data-metafield');
        const isQuickview = vieveSociety.getAttribute('data-quickview');
  
        if(customer == null && vieveMetafield == 'true' && isQuickview == 'false') {
          vieveSociety.style.display = 'block';
          nonVieveSociety.style.display = 'none';
        } else {
          nonVieveSociety.style.display = 'block';
          vieveSociety.style.display = 'none';
        }
      }, 300);

    }
  }
  customElements.define('product-group-swatch', productGroupSwatch)
}